// extracted by mini-css-extract-plugin
export default {"pageLayout":"ob-z","mainContent":"pb-z","activeSidebar":"qb-z","columnLayout":"rb-z","columnLayoutFill":"sb-z","columnLayoutLast":"tb-z"};